export const GET_CHARIOT_START = "vehicle/GET_CHARIOT_START";
export const GET_CHARIOT_REQUEST = "vehicle/GET_CHARIOT_REQUEST";
export const GET_CHARIOT_SUCCESS = "vehicle/GET_CHARIOT_SUCCESS";
export const GET_CHARIOT_FAILURE = "vehicle/GET_CHARIOT_FAILURE";
